<template lang="pug">
y-dialog(v-if="showDialog" v-model="showDialog" max-width="740" persistent fluid scrollable content-class="round-2xl")
  v-card
    v-card-title.px-4.py-3
      v-row(no-gutters align="center")
        v-col(cols="10" offset="1")
          .text-md.font-semibold.text-center Underlying conditions & Allergies
        v-col(cols="1" align="right")
          v-btn(icon @click="showDialog = false" small color="primary")
            v-icon mdi-close
    v-divider
    v-card-text.primary--text.pa-6
      underlying-conditions-section(:items.sync="selectedConditions")
      v-divider.my-6
      allergies-section(:items.sync="selectedAllergies")
    v-divider
    v-card-actions.py-3.px-4
      v-spacer
      y-button.mr-3(:label="$t('cancel')" text color="neutral700" size="sm" button-class="px-0" @click="showDialog = false")
      y-button(label="Save" color="neutral700" size="sm" button-class="px-3" dark :loading="isLoading" @click="save")

</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import UnderlyingConditionsSection from '@/components/clinic/consultation/UnderlyingConditionsSection.vue'
import AllergiesSection from '@/components/clinic/consultation/AllergiesSection.vue'

export default {
  components: { UnderlyingConditionsSection, AllergiesSection },
  props: {
    open: {
      type: Boolean,
      default: false
    },
    allergies: {
      type: Array,
      default: () => []
    },
    underlyingConditions: {
      type: Array,
      default: () => []
    },
    patientId: {
      type: Number,
      required: true,
    }
  },
  data: () => ({
    isLoading: false,
    selectedAllergies: [],
    selectedConditions: []
  }),
  computed: {
    ...mapGetters({
      company: 'getCompany',
      hqSelectedCompany: 'hq/getSelectedCompany',
      isHq: 'hq/getIsHq'
    }),
    showDialog: {
      get () {
        return this.open 
      },
      set (newValue) {
        this.$emit('update:open', newValue)
      }
    }
  },
  mounted () {
    if (this.allergies && this.allergies.length > 0) {
      this.selectedAllergies = this.allergies.map(m => { return { ...m, editable: false } })
    } else {
      this.selectedAllergies.push({ name: null, reactions: null, editable: true })
    }
    if (this.underlyingConditions && this.underlyingConditions.length > 0) {
      this.selectedConditions = this.underlyingConditions.map(m => { return { ...m, editable: false } })
    } else {
      this.selectedConditions.push({ name: null, remarks: null, editable: true })
    }
  },
  methods: {
    ...mapActions(['showMessage']),
    save () {
      this.isLoading = true
      const params = {
        underlying_conditions: this.selectedConditions.filter(item => Boolean(item.name)),
        allergies: this.selectedAllergies.filter(item => Boolean(item.name))
      }
      const companySlug = this.isHq ? this.hqSelectedCompany.slug : this.company.slug
      this.$axios.patch(`/clinics/${companySlug}/patients/${this.patientId}/record`, params)
        .then(resp => {
          this.showMessage(['success', this.$t('success_message.successfully_updated')])
          this.$emit('updated', resp.data)
          this.showDialog = false
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isLoading = false
        })
    }
  }
}
</script>

<style lang="scss" scoped>
</style>